import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetFollowList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Follow/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/myCollection.js